<template>
    <div class="main-content-container container-fluid px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 text-center text-sm-left mb-0 flex-header">
                <h3 class="page-title">Klienci</h3>
                <d-button
                    theme="success"
                    @click="$router.push({name: 'client-new'})">
                    <i class="material-icons">add</i> Nowy klient
                </d-button>
            </div>
        </div>

        <!-- Default Light Table -->
        <template v-if="loadError">
            <d-alert
                show
                theme="warning">
                Wczytywanie danych nie powiodło się.
                <a
                    href="javascript:window.location.reload();"
                    class="alert-link">
                    Odśwież stronę
                </a>
                aby spróbować ponownie.
            </d-alert>
        </template>
        <template v-else>
            <transition name="fade">
                <d-card class="card-small">
                    <div
                        v-if="!loaded"
                        class="overlay-loading">
                        <h2 class="preloader isLoading">Trwa ładowanie</h2>
                    </div>
                    <d-card-header class="border-bottom flex-header">
                        <div class="search-wrapper">
                            <d-input-group>
                                <v-select
                                    v-model="filters.company_id"
                                    :options="allCompanies"
                                    :placeholder="'Spółka'"
                                    :reduce="(option) => option.id"
                                    class="autocomplete-wrapper"
                                    label="name" />
                                <d-input
                                    class="form-control"
                                    placeholder="Imię"
                                    v-model="filters.name" />
                                <d-input
                                    class="form-control"
                                    placeholder="Nazwisko lub nazwa spółki lub NIP"
                                    v-model="filters.surname"
                                    style="min-width: 260px" />
                            </d-input-group>
                            <d-input-group>
                                <d-input
                                    class="form-control"
                                    placeholder="Email"
                                    v-model="filters.email" />
                                <d-input
                                    class="form-control"
                                    placeholder="Telefon"
                                    v-model="filters.phone" />

                                <d-select
                                    type="text"
                                    name="status"
                                    v-model="filters.status"
                                    style="min-width: 260px">
                                    <option :value="null">--Wybierz status</option>
                                    <option
                                        :value="status.value"
                                        v-for="status in statuses"
                                        :key="status.id">
                                        {{ status.name }}
                                    </option>
                                </d-select>
                                <button
                                    class="button btn autocomplete-clear btn-primary"
                                    @click.prevent="filterList">
                                    Szukaj
                                </button>
                                <button
                                    class="button btn autocomplete-clear btn-secondary"
                                    @click.prevent="clearFilters">Wyczyść
                                </button>
                            </d-input-group>
                        </div>
                        <div class="clients-stats">
                            <ss-popover class="client-stat potential">
                                <i class="material-icons">
                                    account_box
                                </i>
                                <strong>{{ potential_clients_number }}</strong>
                                <template slot="tooltip">Liczba potencjalnych kientów</template>
                            </ss-popover>
                            <ss-popover class="client-stat processing">
                                <i class="material-icons">
                                    assignment_ind
                                </i>
                                <strong>{{ processing_clients_number }}</strong>
                                <template slot="tooltip">Liczba klientów w trakcie procesowania</template>
                            </ss-popover>
                            <ss-popover
                                class="client-stat contract"
                                variant="left">
                                <i class="material-icons">
                                    assignment
                                </i>
                                <strong>{{ with_contract_clients_number }}</strong>
                                <template slot="tooltip">Liczba klientów z umową</template>
                            </ss-popover>
                        </div>
                    </d-card-header>
                    <d-card-body class="p-0 pb-2 text-center">
                        <table class="table mb-0 responsive-table">
                            <thead class="bg-light">
                                <tr>
                                    <th scope="col" class="border-0">ID</th>
                                    <th scope="col" class="border-0 text-left">Klient</th>
                                    <th scope="col" class="border-0">Adres e-mail</th>
                                    <th scope="col" class="border-0">Telefon</th>
                                    <th scope="col" class="border-0">Status</th>
                                    <th scope="col" class="border-0">Akcja</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(client) in clients"
                                    :key="client.id">
                                    <td>
                                        <dt>ID</dt>
                                        <dd>{{ client.id }}</dd>
                                    </td>
                                    <td class="text-left">
                                        <template v-if="client.type === 'buisness_activity'">
                                            <dt>Imię i Nazwisko</dt>
                                            <dd>
                                                {{ client.name  + ' ' + client.surname }}
                                                <span v-if="client.is_second_person && client.is_second_person.toString() === '1'">
                                                    ,<br />
                                                    {{ client.second_name }} {{ client.second_surname }}
                                                </span>
                                            </dd>
                                        </template>
                                        <template v-if="client.type === 'corporation'">
                                            <dt>Spółka</dt>
                                            <dd>{{ client.company_name }}</dd>
                                        </template>
                                        <d-badge
                                            v-if="!!client.client_internal"
                                            theme="info" >
                                            Klient dla umów wewnętrznych
                                        </d-badge>
                                    </td>
                                    <td>
                                        <dt>Adres e-mail</dt>
                                        <dd>{{ client.email ? client.email : client.second_email }}</dd>
                                    </td>
                                    <td>
                                        <dt>Telefon</dt>
                                        <dd>{{ client.phone ? client.phone : client.second_phone }}</dd>
                                    </td>
                                    <td>
                                        <dt>Status</dt>
                                        <dd>{{ statusByValue(client.status) }}</dd>
                                    </td>
                                    <td>
                                        <dt>Akcja</dt>
                                        <dd>
                                            <d-button
                                                @click="editClient(client.id)">
                                                <i class="material-icons">search</i> Pokaż
                                            </d-button>
                                            <d-button
                                                v-if="getUser.is_admin === 1"
                                                theme="danger"
                                                class="mr-1 ml-3"
                                                @click="removeClient(client)"
                                                :disabled="removeInProgress">
                                                <i class="material-icons">delete</i> Usuń
                                            </d-button>
                                        </dd>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p
                            v-if="clients.length < 1"
                            class="text-info">
                            Brak klientów do wyświetlenia.
                        </p>
                        <ss-pagination
                            :meta-data="paginationMetaData"
                            :initial-page="currentPage" />
                    </d-card-body>
                </d-card>
            </transition>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import clientUtils from '@/utils/client'
import SsPagination from '@/components/common/SsPaginationNew';
import HasFilters from '@/mixins/HasFilters.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import ListUtils from '@/utils/ListUtils.js';
import lodash from 'lodash';

export default {
    name: "ClientsList",
    mixins: [HasFilters, HasPagination],
    components: {
        clientUtils,
        SsPagination,
        lodash
    },
    data(){
        return{
            company: '',
            statuses: clientUtils._statuses,
            potential_clients_number: 0,
            processing_clients_number: 0,
            with_contract_clients_number: 0,
            filters: {
                name: '',
                surname: '',
                email: '',
                company_id: '',
                phone: '',
                status: null
            },
            clients: [],
            loaded: false,
            loadError: false,
            removeInProgress: false
        }
    },
    computed:{
        ...mapGetters([
            'allCompanies',
            'getUser'
        ])
    },
    mounted () {
        this.getAllCompanies();
        this.loadClients();
    },
    methods: {
        ...mapActions([
            'getAllCompanies'
        ]),
        statusByValue (val) {
            let status = this.statuses.length > 0 ? this.statuses.find(x => x.value === val) : '';
            return status.name;
        },
        editClient (id) {
            this.$router.push({name: 'client-edit', params: {id: id}})
        },
        removeClient(client) {
            this.removeInProgress = true;

            ListUtils.removeItem(this, {
                endpointBase: '/api/clients/remove-client',
                id: client.id,
                successTitle: 'Klient został usunięty',
                successText: '',
                confirmTitle: 'Uwaga',
                confirmText: 'Czy potwierdzasz usunięcie klienta<br /><strong>' +  (client.type === 'corporation' ?  client.company_name : client.name  + ' ' + client.surname) + '</strong>?',
                errorTitle: 'Wystąpił błąd',
                errorText: 'Usuwanie klienta nie powiodło się. Spróbuj ponownie.',
                successAction: () => {
                    this.removeInProgress = false;
                    this.debouncedLoadFilteredData();
                },
                cancelAction: () => {
                    this.removeInProgress = false;
                },
            });
        },
        loadClients () {
            ListUtils.loadItemsData(this, {
                method: 'post',
                endpoint: '/api/clients/get-clients',
                listField: 'clients',
                pagination: true,
                params: {
                    page: this.currentPage,
                    where: this.filters,
                    short: true
                },
                successAction: (responseData) => {
                    this.potential_clients_number = responseData.potential_clients_number;
                    this.processing_clients_number = responseData.processing_clients_number;
                    this.with_contract_clients_number = responseData.with_contract_clients_number;
                }
            });
        },
        debouncedLoadFilteredData: _.debounce(function () {
            Vue.set(this, 'loaded', false);
            Vue.set(this, 'loadError', false);
            this.loadClients();
        }, 500),
        filterList () {
            Vue.set(this, 'loaded', false);
            Vue.set(this, 'loadError', false);
            this.$bus.$emit('pagination-reset');
            this.$bus.$emit('view-filters-save');
        },
        clearFilters () {
            Vue.set(this, 'loaded', false);
            Vue.set(this, 'loadError', false);
            this.filters = {
                name: '',
                surname: '',
                email: '',
                company_id: '',
                phone: '',
                status: null
            };
            this.company = '';
            this.$bus.$emit('view-filters-reset');
            this.$bus.$emit('pagination-reset');
        },
    }
}
</script>


<style scoped lang="scss">
.clients-stats {
    font-size: 30px;
}


span.has-popover.client-stat {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    width: 70px;
    height: 70px;
    color: white;
    background: #007bff;
    margin: 0 15px;
    border-radius: 50%;
    align-items: center;
    &.processing{
        background-color: #fb7906;
    }
    &.contract{
        background-color: #17c671;
    }
}

span.has-popover.client-stat strong {
    font-size: 20px;
    line-height: 1em;
    margin-top: 2px;
}
</style>
